import { Routes, Route } from "react-router-dom";
import Homepage from "../Pages/Homepage";
import ErrorPage from "../Pages/ErrorPage";
import LoginPage from "../Pages/LoginPage";
import EmailPage from "../Pages/EmailPage";
import UserActivityReportTable from "../Pages/UserActivityReportTable";

const PrivateRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<EmailPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/deprecated/home" element={<Homepage />} />
        <Route path="/notFound" element={<ErrorPage />} />
        <Route path="/deprecated/userActivity" element={<UserActivityReportTable /> } />
      </Routes>
    </>

  );
}

export default PrivateRoutes